import React from "react";
import LogoWhite from '.././assets/images/logo-white.png';

import Location from '.././assets/images/location.svg';
import Call from '.././assets/images/call.svg';
import Mail from '.././assets/images/sms.svg';


import Facebook from '.././assets/images/facebook.svg';
import Linkedin from '.././assets/images/instagram.svg';
import Instagram from '.././assets/images/linkedin.svg';


function Footer(){
    return(
        <div>
            <footer>
                <div className="row">
                    <div className="col-md-6 col-sm-6">
                        <div className="logo">
                            <a href="https://www.spurtreetech.com/">
                                <img src={LogoWhite} alt="logo" />
                            </a>
                        </div>
                        <article className="address">
                            <div className="location">
                                <span><img src={Location} alt="icon" /></span>
                                <div>
                                    <p><strong>USA:</strong> 300 S. 4th Street, Suite 180 Las Vegas, NV 89101</p>
                                    <p><strong>India:</strong> SpurTree Technologies, 2004, 100 Feet Rd, HAL 2nd Stage, Indiranagar, Bengaluru, Karnataka 56008</p>
                                </div>
                            </div>
                            <div className="location">
                                <span><img src={Call} alt="icon" /></span>
                                <p>
                                    <a href="tel:+17252539299">(725) 253-9299</a>
                                    <a href="tel:+919731527787">(91) 97315-27787</a>
                                </p>
                            </div>
                            <div className="location">
                                <span><img src={Mail} alt="icon" /></span>
                                <p><a href="mailto:talktous@spurtreetech.com">talktous@spurtreetech.com</a></p>
                            </div>
                        </article>
                    </div>
                    <div className="col-md-3 col-sm-3 col-6">
                        <h4>Quick-links</h4>
                        <ul>
                            <li>
                                <a href="https://www.spurtreetech.com/">Home</a>
                            </li>
                            <li>
                                <a href="https://www.spurtreetech.com/about-us/">About Us</a>
                            </li>
                            <li>
                                <a href="https://www.spurtreetech.com/our-services/"Services></a>
                            </li>
                            <li>
                                <a href="https://careers.spurtreetech.com/spurtreetech/">Careers</a>
                            </li>
                            <li>
                                <a href="https://www.spurtreetech.com/contact-us/">Contact Us</a>
                            </li>
                            <li>
                                <a href="https://www.spurtreetech.com/blogs/">Blogs</a>
                            </li>
                        </ul>
                    </div>
                    <div className="col-md-3 col-sm-3 col-6">
                    <h4>Our Products</h4>
                        <ul>
                            <li>
                                <a href="https://web.sttarter.com/" target="_blank" rel="noopener">STTarter</a>
                            </li>
                            <li>
                                <a href="https://traccar.spurtreetech.com/" target="_blank" rel="noopener">Traccar</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </footer>
            <div className="bottomFooter">
                <p>Copyright © 2025 SpurTree Technologies. All rights reserved.</p>
                <ul>
                    <li>
                        <a href="https://www.facebook.com/spurtreetech/">
                            <img src={Facebook} alt="icon" />
                        </a>
                    </li>
                    <li>
                        <a href="https://www.instagram.com/spurtreetech/">
                            <img src={Instagram} alt="icon" />
                        </a>
                    </li>
                    <li>
                        <a href="https://in.linkedin.com/company/spurtreetech">
                            <img src={Linkedin} alt="icon" />
                        </a>
                    </li>
                   
                </ul>
            </div>
        </div>
    )
}

export default Footer;